import { styled, Theme } from "@mui/material";

export const useStyles = (theme: Theme) => {
  return {
    dialogPaper: {
      height: "80vh",
      minWidth: "60vw",
      overflow: "hidden",
    },
    dialogContent: {
      padding: "0 24px",
      overflow: "auto",
      height: "100%",
    },
    dialogAction: {
      justifyContent: "center",
    },
    button: {
      margin: theme.spacing(1),
      width: "10rem",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(0, 0, 3),
      width: "90%",
      height: "80%",
      maxWidth: "1240px",
      position: "relative",
    },
    checkBox: {
      padding: "5px 9px",
    },
    overlay: {
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 99999,
      cursor: "pointer",
    },
    dailogAction: {
      width: "100%",
      textAlign: "end" as const,
      margin: "20px 20px 10px",
    },
    options: {
      display: "flex",
      justifyContent: "flex-end",
      position: "sticky" as const,
      top: 0,
      zIndex: 1000,
      alignItems: "center",
    },
    optionsContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    instructionText: {
      margin: 0,
    },
    checkboxContainer: {
      display: "flex",
      flexDirection: "column" as const,
    },
    checkboxOption: {
      margin: 0,
    },
    linkedCategoriesSection: {
      marginTop: "12px",
    },
    sectionTitle: {
      marginBottom: "20px",
    },
    linkedCategoriesList: {
      display: "flex",
      flexDirection: "column" as const,
    },
    linkedCategoryItem: {
      margin: 0,
    },
  };
};

export const styleClasses = {
  overlay: "overlay",
  actiondiv: "actiondiv",
  spanSelect: "spanSelect",
  spanUnselect: "spanUnselect",
  message: "message",
};

export const StyledDiv = styled("div")(({ theme }) => ({
  [`&.${styleClasses.overlay}`]: {
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 99999,
    cursor: "pointer",
  },
  [`&.${styleClasses.actiondiv}`]: {
    width: "100%",
    textAlign: "end",
    margin: "20px 20px 10px",
  },
  [`&.${styleClasses.message}`]: {
    marginTop: "5px",
  },
}));

export const StyledtextSelect = styled("p")(({ theme }) => ({
  fontSize: "0.875rem",
  margin: "8px",
  color: theme.palette.unifiedSortingRuleModalMenuItem.main,
  cursor: "pointer",
}));
export const StyledtextUnSelect = styled("p")(({ theme }) => ({
  fontSize: "0.875rem",
  margin: "8px",
  color: theme.palette.unSelectTextColor.main,
  cursor: "pointer",
}));
